import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    const url = `https://www.doctormoringa.in`;
    window.location.href = url;
  }, []);
  return <div className="App"></div>;
}

export default App;
